import React, { useState, useEffect } from "react";
import { useAppSelector } from "hooks/redux";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import type { Stripe } from "@stripe/stripe-js";
import { UserType } from "redux/reducers/models/user";

const StripeProvider = ({ children }: { children: React.ReactNode }) => {
  const { facilityStore, customerCartStore, clientPortalStore, authStore, tournamentRegistrationStore, leagueRegistrationStore, clientStore } = useAppSelector(store => store);

  const [stripePromise, setStripePromise] = useState<Promise<Stripe | null> | null>(null);

  useEffect(() => {
    if (facilityStore.facility) {
      let stripeKey = process.env.REACT_APP_STRIPE_PUBLISH_KEY;

      if (facilityStore.facility?.country_code === "US") {
        stripeKey = process.env.REACT_APP_STRIPE_PUBLISH_KEY_US;
      }

      if (stripeKey) {
        setStripePromise(loadStripe(stripeKey));
      }
    } else if (clientStore.client) {
      let stripeKey = process.env.REACT_APP_STRIPE_PUBLISH_KEY;

      if (clientStore.client?.country_code === "US") {
        stripeKey = process.env.REACT_APP_STRIPE_PUBLISH_KEY_US;
      }

      if (stripeKey) {
        setStripePromise(loadStripe(stripeKey));
      }
    } else if (customerCartStore.cart?.facility) {
      let stripeKey = process.env.REACT_APP_STRIPE_PUBLISH_KEY;

      if (customerCartStore.cart?.facility?.country_code === "US") {
        stripeKey = process.env.REACT_APP_STRIPE_PUBLISH_KEY_US;
      }

      if (stripeKey) {
        setStripePromise(loadStripe(stripeKey));
      }
    } else if (clientPortalStore.selectedFacility) {
      let stripeKey = process.env.REACT_APP_STRIPE_PUBLISH_KEY;

      if (clientPortalStore.selectedFacility?.country_code === "US") {
        stripeKey = process.env.REACT_APP_STRIPE_PUBLISH_KEY_US;
      }

      if (stripeKey) {
        setStripePromise(loadStripe(stripeKey));
      }
    } else if (leagueRegistrationStore.facility) {
      let stripeKey = process.env.REACT_APP_STRIPE_PUBLISH_KEY;

      if (leagueRegistrationStore.facility?.country_code === "US") {
        stripeKey = process.env.REACT_APP_STRIPE_PUBLISH_KEY_US;
      }

      if (stripeKey) {
        setStripePromise(loadStripe(stripeKey));
      }
    } else if (tournamentRegistrationStore.facility) {
      let stripeKey = process.env.REACT_APP_STRIPE_PUBLISH_KEY;

      if (tournamentRegistrationStore.facility?.country_code === "US") {
        stripeKey = process.env.REACT_APP_STRIPE_PUBLISH_KEY_US;
      }

      if (stripeKey) {
        setStripePromise(loadStripe(stripeKey));
      }
    } else if (authStore.user && authStore.user.user_type === UserType.STANDARD_CUSTOMER) {
      const stripeKey = process.env.REACT_APP_STRIPE_PUBLISH_KEY;

      if (stripeKey) {
        setStripePromise(loadStripe(stripeKey));
      }
    }
  }, [facilityStore.facility, customerCartStore.cart?.facility, clientPortalStore.selectedFacility, authStore.user, clientStore.client]);

  return <Elements stripe={stripePromise}>{children}</Elements>;
};

export default StripeProvider;